import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-zeit', 'BrandZeit', [["path",{"d":"M3 20h18l-9 -16l-9 16"}]]);